import { CvpLocale } from "../WSUtils/getIdLanguage";
import { LocContext } from "./LocContext";

export async function getSourceMap(
  stringContext: LocContext,
  locale: CvpLocale
): Promise<{ [key: string]: string }> {
  if (locale !== CvpLocale.nb) {
    throw new Error(
      `No sources for context/locale: ${stringContext}/${locale}`
    );
  }

  if (stringContext === LocContext.ADMIN) {
    return (await import("../localization/sources/nb/admin")).default;
  }

  if (stringContext === LocContext.CV) {
    return (await import("../localization/sources/nb/cv")).default;
  }

  if (stringContext === LocContext.GENERAL) {
    return (await import("../localization/sources/nb/general")).default;
  }

  if (stringContext === LocContext.JOB) {
    return (await import("../localization/sources/nb/job")).default;
  }

  if (stringContext === LocContext.JOBS) {
    return (await import("../localization/sources/nb/jobs")).default;
  }

  if (stringContext === LocContext.PROFILE) {
    return (await import("../localization/sources/nb/profile")).default;
  }

  if (stringContext === LocContext.WORKSCHEDULE) {
    return (await import("../localization/sources/nb/workSchedule")).default;
  }

  throw new Error(`Unhandled context/locale: ${stringContext}/${locale}`);
}
